import { useState } from 'react';
import { Fill } from 'nano-slots';
import InvoiceQuickEditorDrawerPreview from 'Components/Organisms/InvoiceQuickEditorDrawer/InvoiceQuickEditorDrawerPreview';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from 'Components/Atoms/Button/Button';
import { useQueryClient } from '@tanstack/react-query';
import { deleteInvoice } from 'Services/invoices';
import deleteImage from 'assets/icon-delete.svg';

export default function InvoiceDeleteDrawer(props) {
    const { invoiceId, onCancel, onSubmit, onError } = props;

    const queryClient = useQueryClient();

    const { t } = useTranslation('invoices');
    const [processing, setProcessing] = useState(false);

    const handleDelete = async () => {
        setProcessing(true);
        try {
            await deleteInvoice(invoiceId);
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: ['invoices'] }),
                queryClient.invalidateQueries({ queryKey: ['dashboard'] }),
                queryClient.invalidateQueries({ queryKey: ['transactions'] }),
            ]);
            onSubmit();
        } catch (error) {
            onError(error);
        } finally {
            setProcessing(false);
        }
    };

    return (
        <>
            <Fill name="drawer-stack-preview-desktop">
                <InvoiceQuickEditorDrawerPreview id={invoiceId} />
            </Fill>

            <div className="flex flex-col h-full">
                <div className="mt-6 mb-6">
                    <div className="text-center">
                        <div className="mb-4 flex justify-center">
                            <img src={deleteImage} alt="" />
                        </div>
                        <div className="text-lg font-semibold mb-1 text-dark-blue">{t('delete-invoice')}</div>
                        <div className="mb-8 text-gray-500 text-sm">{t('delete-invoice-description')}</div>
                    </div>
                </div>

                <div className="grow" />

                <div className="sticky bottom-0 bg-white pt-2 pb-4 z-10">
                    <div className="flex gap-2">
                        <Button isBusy={processing} variant="primary" className="grow" onClick={handleDelete}>
                            {t('delete')}
                        </Button>
                        <Button variant="default" className="grow" onClick={onCancel}>
                            {t('cancel')}
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
}

InvoiceDeleteDrawer.propTypes = {
    invoiceId: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
};
